import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Goal } from '../../../core/interfaces';

@Component({
  selector: 'app-financial-aid-help-page',
  templateUrl: './financial-aid-help-page.component.html',
  styleUrls: ['./financial-aid-help-page.component.css'],
  standalone: false,
})
export class FinancialAidHelpPageComponent implements OnInit {
  public env = environment;

  // tools list for help page
  public financialAidHelpPageList: Goal[] = [
    // {
    //   title: 'Financial Aid Tool',
    //   image_key: 'homepageFinancialAidTool',
    //   tool_URL: '/financial-aid-help-pages/financial-aid-tool-help',
    //   help_url: '/financial-aid-help-pages/financial-aid-tool-help',
    //   tool_permission: 'financial-aid',
    //   description:
    //     'Displays aggregate information about financial aid based on type.',
    //   logo_name: 'financialAidTool.svg',
    //   hidden: false,
    // },
    // {
    //   title: 'Types of Financial Aid',
    //   image_key: 'homepageTypesOfFinancialAid',
    //   tool_URL: 'disabled',
    //   help_url: '/financial-aid-help-pages/types-of-financial-aid-help',
    //   tool_permission: '&tabname=ftic_fa_pivot',
    //   description: 'Displays funds breakdown of types of financial aid.',
    //   logo_name: 'typesOfFinancialAid.svg',
    //   hidden: false,
    // },
  ];

  constructor() {}

  ngOnInit(): void {}
}
